import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Media, { MediaElement } from '@/components/base/media'
import MediaParallax from '@/components/base/media-parallax'
import Motion from '@/components/base/motion'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { imageTextRevealAnimation } from './animations/image-text'

export type ImageTextProps = HTMLAttributes<HTMLElement> &
  Partial<{
    title: string
    paragraph: string
    media: MediaElement
  }>

const ImageText = ({ title, paragraph, media, ...props }: ImageTextProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid className="gap-y-[3.2rem]">
          <div className="col-span-4 md:col-span-3 lg:col-span-6">
            <MediaParallax className="relative aspect-[605/450] bg-havana">
              {(mediaRef) => (
                <Media ref={mediaRef} fill fit="cover" {...media} />
              )}
            </MediaParallax>
          </div>

          <div className="col-span-4 md:col-span-3 lg:col-span-5">
            <Motion animation={imageTextRevealAnimation}>
              {(motionRef) => (
                <div ref={motionRef} className="grid gap-y-[1.6rem]">
                  {title ? (
                    <Typography
                      variant="h5"
                      component="h2"
                      className="font-timesnow"
                      data-motion-title
                    >
                      {title}
                    </Typography>
                  ) : null}

                  {paragraph ? (
                    <Typography
                      variant="body"
                      paragraph
                      className="font-gillsans font-light"
                      data-motion-paragraph
                    >
                      {paragraph}
                    </Typography>
                  ) : null}
                </div>
              )}
            </Motion>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default ImageText
